<template>
  <u-animate-container>
    <div>
      <front-header />
      <div class="container-section">
        <div class="max-container">
          <v-row class="justify-center">
            <v-col cols="12" sm="6">
              <u-animate name="fadeInLeft" class="wow" delay="0.6s">
                <div class="login-left-content">
                  <div class="image-box">
                    <img
                      src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299877383.jpg"
                      alt
                    />
                  </div>
                </div>
              </u-animate>
            </v-col>
          </v-row>
        </div>
      </div>
      <front-footer />
    </div>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import FrontHeader from "../components/layouts/FrontHeader";
import FrontFooter from "../components/layouts/FrontFooter";

export default {
  name: "Login",
  components: {
    UAnimateContainer,
    UAnimate,
    FrontHeader,
    FrontFooter
  }
};
</script>
